import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import debounce from "lodash.debounce";

import Card from "../common/Card";
import GenericTableComponent from "../common/Table";
import { getAllCampaigns } from "../../redux/slices/campaignSlice";
import { getTopBoard } from "../../redux/slices/overviewSlice";
import { convertToLocalCurrency } from '../../utils/currency';

const CardWrapper = styled.div`
  margin-top: 40px;
  width: 100%;
  display: grid;
  gap: 20px;
  margin-bottom: 30px;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 976px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const columns = [
  { id: "campaignName", label: "Name" },
  { id: "campaignObjective", label: "Type" },
  { id: "campaignBudget", label: "Budget" },
  { id: 'reach', label: 'Clicks' },
  { id: 'totalConversion', label: 'Conversions' },
  { id: 'costPerUser', label: 'CPA' },
  { id: 'amountSpent', label: 'Amount Spent' },
  { id: "conversionRate", label: "CR" },
  { id: "campaignReference", label: "Campaign ID" },
  { id: "carrier", label: "Carrier" },
  //{ id: "flow", label: "Flow" },
  { id: "isApproved", label: "Approval" },
];

const CppTab = () => {
  const dispatch = useDispatch();
  const { topboard } = useSelector((state) => state.overview);
  const { campaigns, meta, loading } = useSelector((state) => state.campaign);
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const obj = 'CPP'
  useEffect(() => {
    dispatch(getTopBoard({campaignObj: obj}));
    dispatch(getAllCampaigns({ page, rowsPerPage, campaignObj: obj }));
  }, [dispatch, page, rowsPerPage, obj]);

  const handlePageChange = (event, newPage) => {
      setPage(newPage);
    dispatch(getAllCampaigns({ page: newPage, rowsPerPage, campaignObj: obj }));
  };
  
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    dispatch(getAllCampaigns({ page: 0, rowsPerPage: newRowsPerPage, campaignObj: obj }));
  };

  const debouncedSearch = useCallback(
    (searchTerm) => {
      const debouncedFn = debounce(() => {
        dispatch(getAllCampaigns({ page: 0, rowsPerPage, name: searchTerm }));
      }, 1000);
  
      debouncedFn();
    },
    [dispatch, rowsPerPage]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearch(value);
  };

  const triggerSearch = () => {
    
    dispatch(getAllCampaigns({ page: 0, rowsPerPage, name: search, campaignObj: obj }));
  };

  return (
    <div>
      <CardWrapper>
        <Card
          text={"Total no of Campaigns"}
          totalCount={topboard?.totalCampaigns}
        />
        <Card
          text={"Approved Campaigns"}
          totalCount={topboard?.approvedCampaigns}
        />
        <Card text={"Money spent"} totalCount={convertToLocalCurrency(`${topboard?.moneySpent}`)}  />
      </CardWrapper>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={campaigns}
          filterSearch={true}
          paginate={true}
          viewLink="/view-campaign"
          editLink="/edit-campaign"
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          triggerSearch={triggerSearch}
          search={search}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handleSearchChange={handleSearchChange}
          totalItems={meta?.itemCount || 0}
        />
      )}
    </div>
  );
};

export default CppTab;
